export function parseTCOD(tcod: string): { branchID: number; code: number } {
  if (!tcod || tcod.length === 0) throw new Error("TCOD can't be empty");
  const tcodNum = parseInt(tcod, 36);
  if (isNaN(tcodNum) || tcodNum === 0) throw new Error(`Invalid TCOD value "${tcod}"`);
  return {
    branchID: Math.floor(tcodNum / 1000),
    code: tcodNum % 1000
  };
}
